<template>
  <transition
    v-if="show"
    enter-class="transform -translate-x-menu-sidebar sm:-translate-x-full"
    leave-to-class="transform -translate-x-menu-sidebar sm:-translate-x-full"
    name="slide"
  >
    <div
      class="
        bg-white
        bottom-0
        fixed
        h-full
        left-0
        menu-sidebar
        sm:top-25.5
        sm:w-[70%]
        top-24
        w-[285px]
        z-20
      "
      id="menu-sidebar"
    >
      <ul class="mt-6">
        <li
          v-for="(item, itemIndex) in list"
          :key="`menu-sidebar-item-${itemIndex}`"
          class="
            bg-white
            cursor-pointer
            flex
            hover:bg-primary-500
            hover:text-white
            text-primary-500
            items-center
            justify-end
            menu-sidebar__item
            py-4
          "
          @click="goPage(item.to)"
        >
          <i :class="item.icon" class="menu-sidebar__item--icon mr-4 text-xl" />
          <i :class="item.hoverIcon" class="menu-sidebar__item--icon mr-4 text-xl" />
          <span class="flex-grow flex-shrink-0">
            {{ item.title }}
          </span>
        </li>
        <li
          class="
            bg-white
            cursor-pointer
            flex
            hover:bg-primary-500
            hover:text-white
            text-primary-500
            items-center
            justify-end
            menu-sidebar__item
            py-4
          "
        >
          <a class="contents" href="https://help.takeorder.tw/" target="_blank">
            <i class="icon-question-mark menu-sidebar__item--icon mr-4 text-xl" />
            <i class="icon-question-mark-white menu-sidebar__item--icon mr-4 text-xl" />
            <span class="flex-grow flex-shrink-0">
              幫助中心
            </span>
          </a>
        </li>
        <li
          class="
            bg-white
            cursor-pointer
            flex
            hover:bg-primary-500
            hover:text-white
            text-primary-500
            items-center
            justify-end
            menu-sidebar__item
            mt-14
            py-4
          "
          @click="logout"
        >
          <i class="icon-logout menu-sidebar__item--icon mr-4 text-xl" />
          <i class="icon-logout-white menu-sidebar__item--icon mr-4 text-xl" />
          <span class="flex-grow flex-shrink-0">
            登出
          </span>
        </li>
      </ul>
    </div>
  </transition>
</template>

<script>
import MenuSidebar from './MenuSidebar';

export default MenuSidebar;
</script>

<style lang="scss" scoped>
@import 'MenuSidebar';
</style>
